export { default as Img200 } from './processed/200/Banshee-S1.jpg';
export { default as Img400 } from './processed/400/Banshee-S1.jpg';
export { default as Imgthumb } from './processed/thumb/Banshee-S1.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Banshee-S1.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Banshee-S1.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      212,
      45,
      53
    ],
    "_population": 1365,
    "_hsl": [
      0.9920159680638722,
      0.6600790513833994,
      0.503921568627451
    ]
  },
  "LightVibrant": {
    "_rgb": [
      224,
      180,
      116
    ],
    "_population": 2173,
    "_hsl": [
      0.09876543209876544,
      0.6352941176470588,
      0.6666666666666666
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      100,
      99,
      21
    ],
    "_population": 1897,
    "_hsl": [
      0.16455696202531647,
      0.6528925619834711,
      0.2372549019607843
    ]
  },
  "Muted": {
    "_rgb": [
      156,
      138,
      98
    ],
    "_population": 2920,
    "_hsl": [
      0.11494252873563214,
      0.2283464566929134,
      0.4980392156862745
    ]
  },
  "LightMuted": {
    "_rgb": [
      204,
      164,
      156
    ],
    "_population": 1,
    "_hsl": [
      0.027777777777777776,
      0.32000000000000006,
      0.7058823529411765
    ]
  },
  "DarkMuted": {
    "_rgb": [
      86,
      82,
      38
    ],
    "_population": 33,
    "_hsl": [
      0.15277777777777776,
      0.3870967741935484,
      0.2431372549019608
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Banshee-S1.js